import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5e0a0c9a"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
import NewTopic from './newTopic/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useRouter } from 'vue-router';
import { debounce, deepCloneByJSON } from '@/utils/tools';
import { onMounted, ref } from 'vue';
import { messageBox } from "@/utils/validate";
import { elMessage } from '@/utils';
import { clearData } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
import { getCurrentTime } from "@/utils/timeFormat";
import { getTopicListApi, deleteThemeApi } from '@/api/vodNew';
const __default__ = {
  name: 'TopicManagement'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const {
      t
    } = useI18n();
    onMounted(() => {
      getData();
    });
    const router = useRouter();
    const tableRef = ref(null);
    const searchConfig = reactive({
      formData: {
        name: ''
      },
      formList: [{
        label: '主题名称',
        prop: 'name',
        widgetType: 'input'
      }],
      search: () => {}
    });
    const tableConfig = reactive({
      data: [],
      paginationConfig: usePageConfig(),
      isShowHeader: true,
      scrollbarAlwaysOn: true,
      listName: '主题管理',
      headerButtonsList: [{
        label: '新增',
        func: () => {
          newTopic.visible = true;
          newTopic.action = 'add';
          newTopic.data = {};
        }
      }],
      columnList: [{
        label: '序号',
        prop: 'no',
        width: 89
      }, {
        label: '主题名称',
        prop: 'name',
        sortable: 'custom',
        width: 200
      }, {
        label: '主题类型',
        prop: 'c_type',
        sortable: 'custom',
        width: 150
      }, // {
      //     label: '主题内容类型', prop: 'contentType', width: 160, sortable: 'custom',
      //     formatter: (val) => {
      //         if (val !== undefined && val !== '' && val !== null) {
      //             return t(val + '_s')
      //         }
      //     }
      // },
      {
        label: '推荐位模板',
        prop: 'layoutImage',
        width: 230,
        cellSlot: true,
        showOverflowTooltip: false
      }, {
        label: '推荐位数量',
        prop: 'itemCount',
        sortable: 'custom',
        width: 240
      }, {
        label: '是否4K',
        prop: 'is4k',
        width: 120,
        formatter: val => val == 1 ? t('是') : t('否')
      }, {
        label: '描述',
        prop: 'description'
      }, {
        label: '创建时间',
        prop: 'createTime',
        sortable: 'custom',
        width: 170
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        showOverflowTooltip: false,
        fixed: 'right',
        minWidth: 160,
        buttonsList: [{
          label: '查看',
          func: data => {
            newTopic.data = deepCloneByJSON(data);
            newTopic.visible = true;
            newTopic.action = 'check';
          }
        }, {
          label: '修改',
          func: data => {
            newTopic.data = deepCloneByJSON(data);
            newTopic.visible = true;
            newTopic.action = 'edit';
          }
        }, {
          label: '删除',
          func: row => {
            messageBox('确定删除这条数据吗?').then(async () => {
              const {
                id
              } = row;
              const {
                code
              } = await deleteThemeApi(id);

              if (code == 0) {
                elMessage('success', '删除成功');
                getData();
              }
            });
          }
        }]
      }],
      config: {
        loading: false
      }
    });
    const newTopic = reactive({
      visible: false,
      action: 'check',
      data: {}
    }); //新增主题按钮

    const addTopic = () => {
      // router.push('/operating/new-topic')
      newTopic.visible = true;
      newTopic.action = 'add';
      newTopic.data = {}; // router.push({name:'NewTopic',params:{type:'add'}})
    }; // 获取主题列表


    const getData = async params => {
      const {
        page,
        limit
      } = tableConfig.paginationConfig;
      tableConfig.config.loading = true;
      let reqParams = {
        pageNo: tableConfig.paginationConfig.page,
        pageSize: tableConfig.paginationConfig.limit,
        ...params,
        ...sortParams
      };
      const res = await getTopicListApi(reqParams);

      if (res.code == 0) {
        tableConfig.data = res.data.map((item, index) => {
          return { ...item,
            c_type: item.type === 'fixed' ? t('固定') : t('运营'),
            createTime: getCurrentTime(item.createTime),
            no: (page - 1) * limit + index + 1
          };
        });
        tableConfig.paginationConfig = {
          total: res.total,
          limit: res.pageSize,
          page: res.current
        };
      }

      tableConfig.config.loading = false;
    }; // 搜索事件


    const handleSearch = data => {
      tableConfig.paginationConfig.page = 1;
      getData(data);
    }; // 重置按钮事件


    const handleReset = () => {
      tableRef.value.commonTableRef.clearSort();
      tableConfig.paginationConfig.page = 1;
      getData();
    }; // 更新列表


    const updateList = () => {
      clearData(searchConfig.formData);
      getData();
    };

    const sortParams = reactive({
      sortTypeEnum: '',
      sortField: ''
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      if (params.order) {
        const sortTypeEnum = params.order.replace('ending', '');
        sortParams.sortTypeEnum = sortTypeEnum;
        sortParams.sortField = params.prop == 'c_type' ? 'type' : params.prop;
        getData();
      } else {
        sortParams.sortTypeEnum = '';
        sortParams.sortField = '';
        getData();
      }
    }, 200);

    const setOptionsBtnColumnWidth = width => {
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem.width = width;
    };

    return (_ctx, _cache) => {
      const _component_SearchForm = _resolveComponent("SearchForm");

      const _component_el_popover = _resolveComponent("el-popover");

      const _component_Column = _resolveComponent("Column");

      const _component_CommonTable = _resolveComponent("CommonTable");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_SearchForm, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: handleSearch,
        onReset: handleReset
      }, null, 8, ["form-list", "form-data"]), _createVNode(_component_CommonTable, {
        "option-column-list": tableConfig.columnList,
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref_key: "tableRef",
        ref: tableRef,
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: getData,
        options: tableConfig.config,
        onSortChange: _unref(handleSortChange)
      }, {
        default: _withCtx(() => [_createVNode(_component_Column, {
          "column-list": tableConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [_createVNode(_component_el_popover, {
            placement: "bottom-start",
            width: 150,
            trigger: "hover"
          }, {
            reference: _withCtx(() => [_createElementVNode("img", {
              class: "logo",
              src: scope.row.layoutImage,
              alt: ""
            }, null, 8, _hoisted_1)]),
            default: _withCtx(() => [_createElementVNode("img", {
              style: {
                "width": "130px",
                "display": "inline-block",
                "text-align": "center"
              },
              src: scope.row.layoutImage,
              alt: ""
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1024)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "table-config", "pagination-config", "options", "onSortChange"])], 512), [[_vShow, !newTopic.visible]]), _createVNode(NewTopic, {
        modelValue: newTopic.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => newTopic.visible = $event),
        action: newTopic.action,
        sourceData: newTopic.data,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "action", "sourceData"])], 64);
    };
  }

});